import { apiInterfaceForJson } from "../common/apiManager";

// RetellAI configuration
export const getRetellConfig = () => {
    return apiInterfaceForJson("/integration/v1/retell-config", "GET");
};

export const updateRetellConfig = (config) => {
    return apiInterfaceForJson("/integration/v1/retell-config", "PUT", config);
};

// Anthropic (Claude) configuration
export const getAnthropicConfig = () => {
    return apiInterfaceForJson("/integration/v1/anthropic-config", "GET");
};

export const updateAnthropicConfig = (config) => {
    return apiInterfaceForJson("/integration/v1/anthropic-config", "PUT", config);
};

export const listAnthropicModels = () => {
    return apiInterfaceForJson("/integration/v1/anthropic-models", "GET");
};

// MMD (MessageWhiz) SMS configuration
export const getMmdConfig = () => {
    return apiInterfaceForJson("/integration/v1/mmd-config", "GET");
};

export const updateMmdConfig = (config) => {
    return apiInterfaceForJson("/integration/v1/mmd-config", "PUT", config);
};

// SMTP email configuration
export const getSmtpConfig = () => {
    return apiInterfaceForJson("/integration/v1/smtp-config", "GET");
};

export const updateSmtpConfig = (config) => {
    return apiInterfaceForJson("/integration/v1/smtp-config", "PUT", config);
};

// Connection tests (provider: "retell" | "anthropic" | "mmd" | "smtp")
export const testIntegrationConnection = (provider) => {
    return apiInterfaceForJson(`/integration/v1/test/${provider}`, "POST");
};
